import React, { useEffect } from 'react';
import Button from './Button';

import '../stylesheets/C.scss';

import { useYouTube } from '../hooks';

function G(props) {
  const youTubeAPIPromise = useYouTube();

  useEffect(() => {
    youTubeAPIPromise.then((yt) => {
      let player = new yt.Player('yt-wild-in-alaska', {
        height: '360',
        width: '640',
        videoId: 'w5PJf40sflc',
        playerVars: { rel: 0, enablejsapi: 1, autoplay: 1, mute: 1, loop: 1, listType: 'playlist', list: 'PL2LNe5vmCj3ayzzIAEMHmq0s7BS47cdTj' },
        title: 'Calm After Crisis',
      });
    });
  }, [youTubeAPIPromise]);

  return (
    <section className="f">
      <div className="video-section">
        <div className="pie-video" id="yt-wild-in-alaska">
          <div id="pie-yt-video"></div>
        </div>
      </div>
      <div className="top-section">
        <h1>My measure of wealth is how many folks I can heal. </h1>
        <h2>
          After devoting his life to service, Manny Salazar is reimagining what wealth really means. See how Manny’s healing journey led him to discover a new purpose in life.
        </h2>
      </div>
      <Button
        message={'Learn More'}
        link={`https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.267028437;dc_trk_aid=461829388;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=`}
      />
    </section>
  );
}

export default G;
